import { render } from "./SearchLink.vue?vue&type=template&id=e2b682c2"
import script from "./SearchLink.vue?vue&type=script&lang=js"
export * from "./SearchLink.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/app.lensmark.kz/mini-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__